import { useState } from "react";
import { ShieldAlert } from "lucide-react";
import { browserName, BROWSER_LABEL, UNBLOCK_STEPS } from "@/lib/micGate";

export const BlockedHelp = () => {
  const [b, setB] = useState(browserName);
  return (
    <div data-testid="mic-blocked-help" className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
      <p className="mb-2 flex items-center gap-1.5 font-bold"><ShieldAlert className="h-4 w-4" />Your browser is blocking the microphone</p>
      <p className="mb-3 text-xs">It won't show the permission pop-up again, so you need to allow it in your browser settings:</p>
      <div className="mb-3 flex flex-wrap gap-1.5" data-testid="mic-browser-tabs">
        {Object.keys(UNBLOCK_STEPS).map((k) => (
          <button key={k} data-testid={`mic-browser-${k}`} onClick={() => setB(k)} className={`rounded-full px-2.5 py-1 text-[11px] font-bold transition-colors ${b === k ? "bg-amber-600 text-white" : "bg-white text-amber-800 hover:bg-amber-100"}`}>{BROWSER_LABEL[k]}</button>
        ))}
      </div>
      <ol data-testid="mic-unblock-steps" className="list-decimal space-y-1 pl-5 text-xs leading-relaxed">{UNBLOCK_STEPS[b].map((s) => <li key={s}>{s}</li>)}</ol>
      <p className="mt-3 text-[11px] text-amber-800">Still blocked? Your computer may block the browser itself: on a Mac open System Settings › Privacy & Security › Microphone; on Windows open Settings › Privacy › Microphone, and allow your browser.</p>
    </div>
  );
};
